import { FC } from 'react'

import { TAccessory } from '@/entities/card/types/types'

import { AccessoriesItem } from '../accessories-item/accessories-item'

import cl from './accessories-list.module.scss'

export const AccessoriesList: FC<{ items: TAccessory[]; relId: number }> = ({ items, relId }) => {
	return (
		<ul className={cl.list}>
			{items &&
				items.map(item => (
					<li className={cl.item} key={item.KOD}>
						<AccessoriesItem {...{ ...item, relId }} />
					</li>
				))}
		</ul>
	)
}
